import React from 'react';
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import {ListItem} from 'material-ui/List';
import muiThemeable from 'material-ui/styles/muiThemeable';
import DOMPurify from "dompurify";
import {NEWS_PAGE} from "../../constants/routes";
import withTranslation from "../../hoc/withTranslation";
import style from "../../styles/styles";
import MediasService from "../../services/medias";
import { Avatar, Chip } from 'material-ui';
import Pages from 'material-ui/svg-icons/communication/comment';
import styles from '../page/PageItem.css';


class NewsItem extends React.Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        news: PropTypes.object.isRequired,
        app: PropTypes.object.isRequired
    };


    // Render

    renderFirstMedia() {
        let news = this.props.news;

        if (news.medias) {
            let images = MediasService.sortedMediasForShortMime(news.medias, MediasService.IMAGES);

            if (images.length > 0) {
                return <Avatar src={images[0].link} style={style.image.cover}/>;
            }
        }

        return <Avatar icon={<Pages/>}/>;
    }

    render() {
        const {news} = this.props;
        const isRichText = news.excerpt
            && news.excerpt.startsWith('<');
        return (
            <Link
                to={NEWS_PAGE.replace(':appId', this.props.app.id).replace(':newsId', this.props.news.id)}>
                <ListItem
                    insetChildren={true}
                    leftAvatar={this.renderFirstMedia()}
                    primaryText={

                        <div>
                            {news.title || this.props.t('module.news.no_title')}
                            {news.tag &&
                            <Chip style={{...styles.chip, ...style.chip}}>
                                {news.tag}
                            </Chip>
                            }
                        </div>
                    }
                    secondaryText={
                        isRichText ?
                            <div
                                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(news.excerpt)}}
                            />
                            : news.excerpt
                    }
                    secondaryTextLines={isRichText ? 2 : 1}
                    disableKeyboardFocus={true}
                >
                </ListItem>
            </Link>
        );
    }
}

export default muiThemeable()(withTranslation(NewsItem));



// WEBPACK FOOTER //
// src/components/news/NewsItem.js